import { SecurityApi as SecurityApiGen, EntitlementApi as EntitlementApiGen } from './gen/security'
import { RestApiConfiguration } from './config'

export const SecurityApi = new SecurityApiGen(RestApiConfiguration)
export const EntitlementApi = new EntitlementApiGen(RestApiConfiguration)
